// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { LAYOUT } from 'constant/layout.constant'
import { NEWS_MODULE, NEWS_URL } from 'constant/url.constant'

// UI
const { NewsIndex, NewsDetail } = lazily(() => import('pages/webpage/news'))

const newsRoutes: IRoute[] = [
  {
    path: NEWS_URL.INDEX,
    component: NewsIndex,
    layout: LAYOUT.DEFAULT,
    exact: true,
    meta: {
      module: NEWS_MODULE,
      requireAuth: false,
      attrs: {
        label: 'news.news',
      },
    },
  },
  {
    path: `${NEWS_URL.INDEX}/:id`,
    component: NewsDetail,
    layout: LAYOUT.DEFAULT,
    exact: true,
    meta: {
      module: NEWS_MODULE,
      requireAuth: false,
      attrs: {
        label: 'news.news',
      },
    },
  },
]

export { newsRoutes }
